import React from 'react';

interface Props {
  fields: Record<string, string>;
}

export const CollectedFieldsTable: React.FC<Props> = ({ fields }) => {
  const entries = Object.entries(fields);
  if (!entries.length) {
    return (
      <p className="text-xs text-text-muted italic">No collected fields yet.</p>
    );
  }
  return (
    <div className="divide-y divide-border rounded-xl border border-border overflow-hidden">
      {entries.map(([key, value]) => (
        <div key={key} className="flex items-center gap-3 px-3 py-2 text-xs">
          <span className="w-1/3 shrink-0 font-medium text-text-secondary capitalize">
            {key.replace(/_/g, ' ')}
          </span>
          <span className="flex-1 truncate text-text-primary">{value}</span>
        </div>
      ))}
    </div>
  );
};
